const Video = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.8 2C0.805887 2 0 2.83574 0 3.86667V14.1333C0 15.1643 0.805887 16 1.8 16H12.6C13.5941 16 14.4 15.1643 14.4 14.1333V12.2667H15.75V12.3344L17.2541 14.8818C17.4399 15.1966 18 15.0846 18 14.7327V3.26728C18 2.91542 17.4399 2.80344 17.2541 3.11816L15.75 5.66557V5.73333H14.4V3.86667C14.4 2.83574 13.5941 2 12.6 2H1.8ZM4.95 6.61738C4.95 6.29738 5.29497 6.09676 5.57222 6.25553L10.1405 8.87148C10.4198 9.03147 10.4198 9.43519 10.1405 9.59519L5.57222 12.2111C5.29497 12.3699 4.95 12.1693 4.95 11.8493V6.61738Z"
      />
    </svg>
  );
};

export default Video;
